import React from 'react';
import { Outlet } from 'react-router-dom';
import NavBar from './common/NavBar';
import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';

const LayoutContent = (): JSX.Element => {
    const { isAuthenticated, user } = useAuth0();
    const { t } = useTranslation();

    const wrapperStyle = isAuthenticated ? 'site-content' : '';
    const verifiedUser = user?.email_verified === true;

    return (
        <div className='site-wrapper'>
            {verifiedUser && <NavBar />}
            <div className={wrapperStyle}>
                <Outlet />
            </div>
            <footer>
                <a
                    href='http://www.view-privacy-policy.co.uk/Privacy-Policy'
                    target='_blank'
                    rel='noopener noreferrer'>
                    {t('privacy_policy')}
                </a>
            </footer>
        </div>
    );
};

export default LayoutContent;
